import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import './index.scss';
import { fetchPersonalAlert } from '../../../main-layout/header/right/alerts/reducer';
import AlertPersonalTable from './Table';
import PersonalForm from './personal-form/PersonalForm';

class AlertPersonal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowForm: false,
      currentItem: null,
    };
  }

  componentDidMount() {
    const { fetchPersonalAlert } = this.props;
    fetchPersonalAlert();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { isShowForm } = this.state;
    const { fetchPersonalAlert } = this.props;
    if (!isShowForm && prevState.isShowForm) {
      fetchPersonalAlert();
    }
  }

  showForm = item => {
    this.setState({
      isShowForm: true,
      currentItem: item,
    });
  };

  hideForm = () => {
    this.setState({
      isShowForm: false,
      currentItem: null,
    });
  };

  render() {
    const { parentRef } = this.props;
    const { currentItem, isShowForm } = this.state;
    if (isShowForm) {
      return (
        <PersonalForm
          hideForm={this.hideForm}
          data={currentItem}
          handleShowEdit={this.showForm}
        />
      );
    }

    return (
      <div className="alert-personal d-flex flex-fill flex-column mt-10">
        <div className="btn-add-setting">
          <button
            className="float-right btn btn-cus bg-b-color-3 dropdown-toggle"
            title={I18n.t('watchListSummary.createNewWatchlistIcon')}
            type="button"
            onClick={() => this.showForm()}
            aria-expanded="false"
          >
            <i className="icon-plus-s fs-11" />
          </button>
        </div>
        <div className="tab-pane active d-flex flex-fill flex-column h-auto">
          <div className="d-flex flex-fill mb-10">
            <AlertPersonalTable
              handleModify={this.showForm}
              parentRef={parentRef}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  fetchPersonalAlert,
};

export default connect(
  null,
  mapDispatchToProps,
)(AlertPersonal);
